import React, { useEffect } from 'react';
import Filter from './Filter';
import ActiveFilters from './ActiveFilters';

const FilterWrapper = ({
  providers,
  sortOptions,
  sort_option,
  selectedSortOption,
  setSortOption,
  setProviderFilter,
  mobile,
  provider,
  openModalFilterCategory,
  handleClearAllFilterCategory,
  handleUnselectFilterCategory,
  filterCategory,
  filterProvider,
  settings,
  plansLength,
}) => {

  useEffect(() => {
    const containsProvider = window.location.href.includes('provider=');

    const filtersWrapper = document.getElementById('filters-wrapper');
    if (filtersWrapper && containsProvider) {
      filtersWrapper.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="filter-wrapper" id="filters-wrapper">
      <div className="wrapper-column">
        <section className="plans-headsup">
          <p className="plans-quantity">
            Encontramos <b className="text-green">{plansLength || 0} seguros viagem</b>
          </p>
          <p>Escolhemos os melhores planos para sua viagem de acordo com seu destino e tempo de permanência.</p>
        </section>

        {plansLength > 0 && (
          <Filter
            setSortOption={setSortOption}
            providers={providers}
            sortOptions={sortOptions}
            sort_option={sort_option}
            selectedSortOption={selectedSortOption}
            setProviderFilter={setProviderFilter}
            mobile={mobile}
            provider={provider}
            openModalFilterCategory={openModalFilterCategory}
            clearFilter={handleClearAllFilterCategory}
            unselectFilterCategoryOptions={handleUnselectFilterCategory}
            filterCategory={filterCategory}
            filterProvider={filterProvider}
            ecommerce_config={settings}
          />
        )}
      </div>

      {mobile && (
        <ActiveFilters
          filterCategory={filterCategory}
          filterProvider={filterProvider}
          handleUnselectFilterCategory={handleUnselectFilterCategory}
          handleClearAllFilterCategory={handleClearAllFilterCategory}
          variant="v1"
        />
      )}
    </div>
  );
};

export default FilterWrapper;



// WEBPACK FOOTER //
// ./src/components/search/plans_table/Filters/FilterWrapper.jsx